import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { AttributesPage } from "../pages";

export const AttributesRoutes: React.FC = () => {
  return (
    <Routes>
      <Route index element={<AttributesPage />} />
      <Route path="*" element={<Navigate to="" replace />} />
    </Routes>
  );
};
